import { TUserSelf } from "@/data/types";

export interface SessionState {
  organizationId: string | null;
  currentUser: TUserSelf | null;
}

export const DefaultSessionState: SessionState = {
  organizationId: null,
  currentUser: null,
};
